import { userRoleDataPermissionsSelector } from "./userRoleDataPermissionsSelector";
import { RootState } from "../../../store";
import { Permission } from "../../../../services/cloudchipr.api";

export const userRoleDataPermissionsGroupsSelector = (state: RootState) => {
  const permissions = userRoleDataPermissionsSelector(state);
  return Object.keys(permissions ?? {}) as Permission["group"][];
};
